import type { LensFilterValues } from '~/types/leLens';

export const LENS_CROSS_FILTER_PREFIX = '__lens_cross_';

/**
 * The source chart needs the board result from before its mark selection was
 * applied so it can retain comparison context and highlight the chosen mark.
 * Dashboard filters and the reporting period remain part of this request.
 */
export function withoutLensCrossFilters(filters: LensFilterValues): LensFilterValues {
  return Object.fromEntries(
    Object.entries(filters).filter(([filterId]) => !filterId.startsWith(LENS_CROSS_FILTER_PREFIX)),
  );
}
